import { useTranslation } from 'react-i18next';
import { Typography, Modal, Button, Switch, Card, Flex } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { ContentCustom, PageHeaderCustom } from '../../../components';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useCallsAPI } from '../utils/callAPI';
import { CardTitle } from '../../../components/CardTitle/CardTitle';

const { Text } = Typography;
const { confirm } = Modal;

export const ShowSettings = () => {
  const [profileID, setProfileID] = useState('');

  const { t } = useTranslation();
  const { user } = useAuthContext();
  const { deleteProfile, getProfile } = useCallsAPI({
    setFunction: (data) => setProfileID(data[0]._id),
    id: profileID
  });

  useEffect(() => {
    (async () => {
      await getProfile();
    })();
  }, []);

  const showDeleteConfirm = () => {
    confirm({
      title: t('settings.messages.delete_account'),
      icon: <ExclamationCircleFilled />,
      okText: t('settings.messages.yes'),
      okType: 'danger',
      cancelText: t('settings.messages.no'),
      onOk() {
        deleteProfile();
      }
    });
  };

  return (
    <>
      <PageHeaderCustom title={t('settings.title')} />
      <ContentCustom transparent style={{ gap: 24 }}>
        {user.role === 'users:PENSIONER' && (
          <Card
            title={
              <CardTitle icon="message">
                {t('settings.manage_notifs')}
              </CardTitle>
            }
          >
            <Flex align="center" justify="space-between" gap={16}>
              <Text>{t('settings.newlestter')}</Text>
              <Switch defaultChecked />
            </Flex>
          </Card>
        )}
        <Card
          title={
            <CardTitle icon="user">{t('settings.manage_profile')}</CardTitle>
          }
        >
          <Button danger onClick={showDeleteConfirm}>
            {t('settings.delete_account')}
          </Button>
        </Card>
      </ContentCustom>
    </>
  );
};
